import { ACTIONS } from '../Constants';

const initialState = {
    byId: {}
};

const behaviors = (state = initialState, action) => {
    let newById;
    let reduced;
    let behavior;

    switch (action.type) {
        case ACTIONS.GET_MANY_BEHAVIORS: {
            const { behaviors = [] } = action.payload;

            reduced = behaviors.reduce((prev, behavior) => {
                prev[behavior._id] = behavior;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_BEHAVIOR:
        case ACTIONS.PUT_BEHAVIOR_SUCCESS:
        case ACTIONS.POST_BEHAVIOR_SUCCESS: {
            ({ behavior } = action.payload);
            newById = {
                ...state.byId,
                [behavior._id]: behavior
            };
            return {
                ...state,
                byId: newById
            };
        }

        default:
            return state;
    }
};

export default behaviors;
